import { traceHandle } from '../tracing'
import { withGlobalOptions } from '../types'
import { fetchProduct } from './fetch'
import { fetchMultipleProducts } from './fetch-multiple'

const productAttributes = { 'shopify.api': 'storefront', 'shopify.operation': 'products' } as const

export const productHandles = withGlobalOptions({
  fetch: traceHandle('shopify.storefront.products.query', productAttributes, fetchProduct),
  fetchMultiple: traceHandle(
    'shopify.storefront.products.query',
    productAttributes,
    fetchMultipleProducts,
  ),
})
